import * as GroupType from 'constants/GroupType';

const BASKETBALL_NCAA_GROUP_MAP = {};

BASKETBALL_NCAA_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
BASKETBALL_NCAA_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
BASKETBALL_NCAA_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
BASKETBALL_NCAA_GROUP_MAP[3] = GroupType.BASKETBALL_MATCH_TWO_POINTS_GROUP;
BASKETBALL_NCAA_GROUP_MAP[4] = GroupType.BASKETBALL_MATCH_THREE_POINTS_GROUP;

export default BASKETBALL_NCAA_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/BasketballNCAA/GroupMap.js